import { fetchKeyFigures } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/dataParsing";

export async function updateKeyFiguresPageState(isMasterKeyValid, languageKey, keyFiguresFilters, setKeyFiguresFilters, setKeyFiguresData) {
  const isInitialLoad = keyFiguresFilters.isInitialLoad;
  const requestBody = extractRequestBodyFromFilters(keyFiguresFilters, isInitialLoad);
  let overheadData = await fetchKeyFigures(languageKey, requestBody, (err) => console.log(err), isMasterKeyValid);
  let { context, reportData } = overheadData.data;
  let submitedFilters = context.filters;
  let nextAvailableFilters = context.nextAvailableFilters;
  let updatedFilters = await updateFilters(keyFiguresFilters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, languageKey);
  setKeyFiguresFilters(updatedFilters);
  setKeyFiguresData(reportData);
}
